import React, { useEffect, useState } from "react";
import { GetSealStatus } from "../../../contexts/SealProvider";
import image from "../../../assets/images/vbg-login.jpg";
import {
  AlertBanner,
  Box,
  Button,
  InputField,
  Loader,
  Typography,
} from "@saviynt/design-system";
import "@saviynt/tokens";
import "./StartPod.css";
import SavContainer from "../../common/SavContainer/SavContainer";

function StartPod() {
  const [email, setEmail] = useState("");
  const [shardKey, setShardKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [isShardVisible, setIsShardVisible] = useState(false);
  const ctx = GetSealStatus();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert(null);
    setIsLoading(true);

    try {
      const response = await fetch("/api/v1/bggw/start", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username: email, password: shardKey }),
      });

      const res = await response.json();

      if (!response.ok || res.errors) {
        const msg = res.errors ? res.errors[0].error : res.error || "Verification failed";
        setAlert({
          colorTheme: "Critical",
          title: "Start Failed",
          description: msg,
        });
        setIsLoading(false);
        return;
      }

      // Start succeeded — keep showing loader until status poll catches up
      if (res.verified || res.status === "POD_CREATED" || res.status === "ALREADY_RUNNING") {
        ctx.refresh();
      }
    } catch (err) {
      setAlert({
        colorTheme: "Critical",
        title: "Network Error",
        description: "Network error. Please try again.",
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let shardTimeout;
    if (isShardVisible) {
      shardTimeout = setTimeout(() => {
        setIsShardVisible(false);
      }, 3000);
    }
    return () => clearTimeout(shardTimeout);
  }, [isShardVisible]);

  return (
    <SavContainer>
      {alert && (
        <AlertBanner
          colorTheme={alert.colorTheme}
          title={alert.title}
          description={alert.description}
          isVisible={true}
          onCancel={() => setAlert(null)}
          isColonVisible={false}
          isFloating
          position={{ type: "fixed", top: "4.25rem" }}
          shouldAutoDismiss
          autoDismissDelay={5000}
        />
      )}
      <img src={image} alt="vbg-start" />
      <Box className="StartPod">
        <Box className="StartPod-form">
          <Box className="StartPod-header">
            <Typography kind="h1">Saviynt Vault Break Glass</Typography>
          </Box>
          {isLoading ? (
            <Box className="StartPod-loader">
              <Loader kind="dots" format="inline" color="info" size="medium" />
              <Typography kind="body" style={{ marginTop: "1rem" }}>
                Starting application...
              </Typography>
            </Box>
          ) : (
            <Box className="StartPod-formContent">
              <InputField
                type="text"
                name="email"
                placeholder="Email"
                value={email}
                setValue={setEmail}
                label={<Typography kind="label">Email:</Typography>}
                classNames={{
                  inputContainer: "StartPod-inputContainer",
                  labelContainer: "StartPod-labelContainer",
                }}
                onKeyDown={(e) => e.key === "Enter" && email && shardKey && handleSubmit(e)}
                isRequired
              />
              <InputField
                type={isShardVisible ? "text" : "password"}
                name="shardKey"
                value={shardKey}
                setValue={setShardKey}
                placeholder="Shard Key"
                label={<Typography kind="label">Shard Key:</Typography>}
                classNames={{
                  inputContainer: "StartPod-inputContainer",
                  labelContainer: "StartPod-labelContainer",
                }}
                suffixButtonType="password"
                suffixIsToggle={isShardVisible}
                suffixOnClick={() => setIsShardVisible(!isShardVisible)}
                onKeyDown={(e) => e.key === "Enter" && email && shardKey && handleSubmit(e)}
                isRequired
              />
              <Box className="StartPod-submitButton">
                <Button
                  type="button"
                  kind="filled"
                  className="StartPod-signIn"
                  onClick={handleSubmit}
                  isDisabled={email === "" || shardKey === ""}
                >
                  Start
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </SavContainer>
  );
}

export default StartPod;
